<template lang="pug">
  button(:class="className", @click="$emit('click')")
    slot(name="left-icon")
    span {{ name.length ? name : 'i\'m button' }}
    slot(name="right-icon")
</template>

<script>
export default {
  name: 'ArcButton',
  props: {
    name: {
      type: String,
      default: '',
      required: false,
    },
    outline: {
      type: Boolean,
      default: false,
      required: false,
    },
    outlineGray: {
      type: Boolean,
      default: false,
      required: false,
    },
    dashed: {
      type: Boolean,
      default: false,
      required: false,
    },
    accent: {
      type: Boolean,
      default: false,
      required: false,
    },
    color: {
      type: String,
      default: '',
      required: false,
    },
  },
  data: () => ({
    className: 'arc-button',
  }),
  mounted() {
    if (this.dashed) {
      this.className += '__dashed';
    } else if (this.outline) {
      this.className += '__outline';
    } else if (this.accent) {
      this.className += '__accent';
    } else if (this.outlineGray) {
      this.className += '__outline-gray';
    }
  },
};
</script>

<style lang="scss">
$--font-family: Inter;
$--accent: rgb(255, 234, 0);
$--gray: rgb(246, 246, 246);
$--text: rgb(0, 0, 0);

%btn-clear {
  appearance: none;
  user-select: none;
  outline: none;
  cursor: pointer;
}

%btn-defaults {
  font-family: $--font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;

  color: $--text;

  height: 50px;
  padding: 0 20px;
  border-radius: 8px;

  transition: all .25s ease-in-out;
}

.arc-button {
  @extend %btn-clear;
  @extend %btn-defaults;
  border: none;
  background-color: $--gray;
  &:hover {
    background-color: $--accent;
  }

  &__accent {
    @extend %btn-clear;
    @extend %btn-defaults;
    border: none;
    background-color: $--accent;
    &:hover {
      background-color: darken($--accent, 10%);
    }
  }

  &__outline {
    @extend %btn-clear;
    @extend %btn-defaults;
    background-color: transparent;
    border: solid 1px $--accent;
    &:hover {
      background-color: $--accent;
    }
  }

  &__outline-gray {
    height: 40px;
    @extend %btn-clear;
    @extend %btn-defaults;
    background: transparent;
    // border: solid 1px $--gray;
    border: solid 1px #e9e0e0;
    &:hover {
      background-color: $--accent;
      border-color: $--accent;
    }
  }

  &__dashed {
    @extend %btn-clear;
    @extend %btn-defaults;
    background-color: transparent;
    border: 1px dashed rgb(229, 229, 229);
    &:hover {
      background-color: rgb(229, 229, 229);
    }
  }
}
</style>
